<template>
    <template-block
        v-if="localModel"
        type="Avdelare"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="block-content-grid">
            <select-with-validation
                v-model="localModel.style"
                :vid="vid + '.style'"
                label="Stil"
                :reduce="(opt) => opt.id"
                :options="[
                    { label: 'Solid', id: 'solid' },
                    { label: 'Prickad', id: 'dotted' },
                    { label: 'Streckad', id: 'dashed' },
                    { label: 'Dubbel', id: 'double' },
                ]"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <input-with-validation
                label="Tjocklek"
                :vid="vid + '.width'"
                v-model="localModel.width"
                @input="emitChange"
                placeholder="Tjocklek"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <color-picker
                label="Färg"
                :vid="vid + '.color'"
                v-model="localModel.color"
                @input="emitChange"
                placeholder="#FFFFFF"
            ></color-picker>
        </div>
    </template-block>
</template>

<script>
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import { genUUID } from '@services/Helpers';
import ColorPicker from '@components/Form/ColorPicker.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';

export default {
    name: 'BlockDivider',
    components: {
        SelectWithValidation,
        InputWithValidation,
        ColorPicker,
        TemplateBlock,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'image.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
    },
    methods: {
        init(newVal) {
            this.localModel = {
                type: 'divider',
                id: newVal.id || genUUID(),
                width: newVal.width ?? 200,
                style: newVal.style || 'solid',
                color: newVal.color || '#cccccc',
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>
